module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    on: {
      "login-as": _vm.loginAs
    }
  }), (_vm.loggedIn) ? _c('div', {
    staticClass: "links"
  }, [(_vm.user.can_see_guestlist) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayGuestList($event)
      }
    }
  }, [_c('span', [_vm._v("GL")]), _c('i', {
    staticClass: "fa fa-calendar-check-o"
  })]) : _vm._e(), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayVacations($event)
      }
    }
  }, [_c('span', [_vm._v("Urlaub")]), _c('i', {
    staticClass: "fa fa-plane"
  })]), (_vm.user.can_view_shift_plan) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.displayShiftPlan($event)
      }
    }
  }, [_c('span', [_vm._v("Schichten")]), _c('i', {
    staticClass: "fa fa-calendar"
  })]) : _vm._e(), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showEmployeeList = true
      }
    }
  }, [_c('span', [_vm._v("Team")]), _c('i', {
    staticClass: "fa fa-users"
  })]), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.loadNews()
      }
    }
  }, [_c('span', [_vm._v("News")]), _c('i', {
    staticClass: "fa fa-newspaper-o"
  })]), _c('a', {
    staticStyle: {
      "margin-right": "17px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('span'), _c('i', {
    staticClass: "fa fa-sign-out"
  })])]) : _vm._e(), (!_vm.loggedIn) ? _c('form', {
    staticClass: "loginForm"
  }, [_c('div', {
    staticClass: "section"
  }, [_vm._m(0), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "name": "username",
      "placeholder": "eMail"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-user"
  })]), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Passwort"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.logMeIn($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-key fa-rotate-90"
  })])])]), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "DGSVO"
    },
    on: {
      "click": function($event) {
        _vm.confirmed = !_vm.confirmed
      }
    }
  }), _c('label', {
    attrs: {
      "for": "DGSVO"
    }
  }, [_vm._v(" Ich akzeptiere die "), _c('a', {
    attrs: {
      "href": this.$root.apiHost + '/datenschutz'
    }
  }, [_vm._v("Datenschutzregelungen")])]), _c('br'), _c('br'), _c('a', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": !_vm.confirmed
    },
    on: {
      "click": _vm.logMeIn
    }
  }, [_vm._v("einloggen")])])])])]) : _vm._e(), (_vm.loggedIn) ? _c('div', {
    staticClass: "section"
  }, [_c('b-aside', {
    staticClass: "presence",
    attrs: {
      "is-show": _vm.editShiftTimes,
      "title": "Anwesenheiten",
      "show-footer": false,
      "placement": "right"
    },
    on: {
      "close": function($event) {
        _vm.editShiftTimes = false
      }
    }
  }, [(_vm.editShiftTimes) ? _c('presence-panel', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e()], 1), _c('b-aside', {
    attrs: {
      "is-show": _vm.showApplications,
      "title": "Bewerbungen",
      "show-footer": false
    },
    on: {
      "close": function($event) {
        _vm.showApplications = false
      }
    }
  }, [_c('applications')], 1), _c('b-aside', {
    attrs: {
      "is-show": _vm.showVacations,
      "title": "Urlaub",
      "show-footer": false
    },
    on: {
      "close": function($event) {
        _vm.showVacations = false
      }
    }
  }, [_c('vacations', {
    attrs: {
      "vacations": _vm.vacations,
      "user": _vm.user
    },
    on: {
      "reload-vacations": _vm.loadVacations
    }
  })], 1), _c('b-aside', {
    attrs: {
      "is-show": _vm.showNews,
      "title": "News",
      "show-footer": false
    },
    on: {
      "close": function($event) {
        _vm.showNews = false
      }
    }
  }, [_c('div', [_vm._v("Hier findest du News vom KA, Deli und aus den Gewerken.")]), _c('br'), _vm._l((_vm.news), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "newsItem"
    }, [_c('div', {
      staticClass: "headline"
    }, [_c('div', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm._f("moment")(new Date(item.created), 'dd. Do MMM ')))]), _c('div', {
      staticClass: "newsType"
    }, [_vm._v(_vm._s(item.type_display))])]), _c('h2', [_vm._v(_vm._s(item.title))]), (item.showContent) ? _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), (item.attachments.length > 0) ? _c('div', {
      staticClass: "attachments"
    }, [_c('b', [_vm._v("Anhänge:")]), _c('ul', _vm._l((item.attachments), function(att) {
      return _c('li', {
        key: att.id
      }, [_c('a', {
        attrs: {
          "href": _vm.apiUrl + att.file,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(att.name))])])
    }), 0)]) : _vm._e()]) : _vm._e(), _c('div', {
      staticClass: "buttons"
    }, [_c('a', {
      staticClass: "button",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          item.showContent = !item.showContent
        }
      }
    }, [_vm._v(_vm._s(item.showContent ? 'Ausblenden' : 'Anzeigen'))])])])
  })], 2), _c('b-aside', {
    attrs: {
      "is-show": _vm.showGuestList,
      "title": "Gästeliste",
      "show-footer": false
    },
    on: {
      "close": function($event) {
        _vm.showGuestList = false
      }
    }
  }, [(!_vm.currentEvent) ? _c('div', [_vm._v("Heute keine Veranstaltung.")]) : _vm._e(), (_vm.currentEvent) ? _c('div', [_c('div', [_c('b', [_vm._v("VA: ")]), _vm._v(_vm._s(_vm.currentEvent.name))]), _c('br'), _c('div', {
    staticClass: "search-bar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.guestSearch),
      expression: "guestSearch"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Gast suchen ..."
    },
    domProps: {
      "value": (_vm.guestSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.guestSearch = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "fa fa-times",
    on: {
      "click": function($event) {
        _vm.guestSearch = ''
      }
    }
  })]), _c('br'), _c('div', {
    staticClass: "legend"
  }, [_c('span', {
    staticClass: "so36",
    class: {
      inactive: _vm.catSearch != 'so36' && _vm.catSearch != ''
    },
    on: {
      "click": function($event) {
        return _vm.setCatSearch('so36')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-beer"
  }), _c('span', [_vm._v("SO36")])]), _c('span', {
    staticClass: "band",
    class: {
      inactive: _vm.catSearch != 'band' && _vm.catSearch != ''
    },
    on: {
      "click": function($event) {
        return _vm.setCatSearch('band')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-music"
  }), _vm._v("Band")]), _c('span', {
    staticClass: "agency",
    class: {
      inactive: _vm.catSearch != 'agency' && _vm.catSearch != ''
    },
    on: {
      "click": function($event) {
        return _vm.setCatSearch('agency')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-briefcase"
  }), _c('span', [_vm._v("Agentur")])]), _c('span', {
    staticClass: "win",
    class: {
      inactive: _vm.catSearch != 'win' && _vm.catSearch != ''
    },
    on: {
      "click": function($event) {
        return _vm.setCatSearch('win')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  }), _c('span', [_vm._v("Gewinnspiel")])])]), _c('br'), _c('div', {
    staticClass: "guest"
  }, [_c('div', {
    staticClass: "info head"
  }, [_c('span', [_vm._v("Kat.")]), _c('span', [_vm._v("Name")]), _c('span', [_vm._v("+X")]), _c('span', [_vm._v("Bänd.")]), _c('span', [_vm._v("Anw.")])]), _c('div', {
    staticClass: "comment"
  }, [_c('span')])]), _vm._l((_vm.filteredGuests), function(guest) {
    return _c('div', {
      staticClass: "guest",
      class: {
        selected: _vm.selectedGuest && _vm.selectedGuest.id == guest.id
      }
    }, [_c('div', {
      staticClass: "info",
      on: {
        "click": function($event) {
          return _vm.selectGuest(guest)
        }
      }
    }, [_c('span', {
      class: guest.category
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.icons[guest.category]
    })]), _c('span', [_vm._v(_vm._s(guest.name))]), _c('span', [_vm._v(_vm._s(guest.plus_x > 0 ? '+' + guest.plus_x : '—'))]), _c('span', [_vm._v(_vm._s(guest.ribbon ? '✔️' : '✖'))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (guest.present),
        expression: "guest.present"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(guest.present) ? _vm._i(guest.present, null) > -1 : (guest.present)
      },
      on: {
        "change": [function($event) {
          var $$a = guest.present,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(guest, "present", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(guest, "present", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(guest, "present", $$c)
          }
        }, function($event) {
          return _vm.updateGuest(guest)
        }],
        "click": [function($event) {
          $event.stopPropagation();
          return true($event)
        }, function($event) {
          _vm.selectedGuest = guest
        }]
      }
    })]), (_vm.selectedGuest && _vm.selectedGuest.id == guest.id && guest.comment != '') ? _c('div', {
      staticClass: "comment"
    }, [_c('span', [_c('b', [_vm._v("Kommentar: ")]), _vm._v(_vm._s(guest.comment))])]) : _vm._e()])
  })], 2) : _vm._e()]), (_vm.user.can_view_shift_plan || _vm.user.is_admin) ? _c('b-aside', {
    staticClass: "plan",
    attrs: {
      "is-show": _vm.showShiftPlan,
      "title": "Schichtplan",
      "show-footer": false,
      "placement": "right"
    },
    on: {
      "close": function($event) {
        _vm.showShiftPlan = false
      }
    }
  }, [_c('div', {
    staticClass: "selection"
  }, [(_vm.canViewAll) ? _c('ul', {
    staticClass: "fields"
  }, [_c('li', {
    class: {
      active: !_vm.fieldFilter
    },
    on: {
      "click": function($event) {
        return _vm.getPlannedDays(null)
      }
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        return _vm.getPlannedDays(null)
      }
    }
  }, [_vm._v("Alle")])]), _vm._l((_vm.fields), function(field) {
    return (field.show_shifts) ? _c('li', {
      class: {
        active: field.id === _vm.fieldFilter
      }
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.getPlannedDays(field.id)
        }
      }
    }, [_vm._v(_vm._s(field.name))])]) : _vm._e()
  })], 2) : _vm._e()]), _c('div', {
    staticClass: "plan"
  }, [_vm._l((_vm.plannedDays), function(day, index) {
    return [(day.is_today) ? _c('a', {
      attrs: {
        "id": "plan-starts-today"
      }
    }) : _vm._e(), _c('planned-day', {
      class: {
        'gray': index % 2 === 0, 'is-today': day.is_today === true
      },
      attrs: {
        "day": day
      }
    })]
  })], 2)]) : _vm._e(), _c('b-aside', {
    staticClass: "employees",
    attrs: {
      "is-show": _vm.showEmployeeList,
      "title": "Team",
      "show-footer": false,
      "placement": "right"
    },
    on: {
      "close": function($event) {
        _vm.showEmployeeList = false
      }
    }
  }, [_c('employees-list', {
    attrs: {
      "fields": _vm.fields,
      "user": _vm.user
    },
    on: {
      "login-as": _vm.loginAs
    }
  })], 1), (_vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "presence"
  }, [_c('div', {
    staticClass: "button yellowbg",
    on: {
      "click": function($event) {
        _vm.editShiftTimes = true
      }
    }
  }, [_vm._v("Anwesenheiten erfassen")]), _c('br'), _c('br')]) : _vm._e(), (_vm.user.can_view_shift_times && !_vm.user.can_record_shift_times) ? _c('div', {
    staticClass: "presence"
  }, [_c('div', {
    staticClass: "button yellowbg",
    on: {
      "click": function($event) {
        _vm.editShiftTimes = true
      }
    }
  }, [_vm._v("Anwesenheiten einsehen")]), _c('br'), _c('br')]) : _vm._e(), _c('span', [_vm._v("Hi " + _vm._s(_vm.user.short_name) + "! Hier sind Deine kommenden Schichten:")]), _c('shifts', {
    attrs: {
      "switchToApplications": _vm.switchToApplications,
      "user": _vm.user
    }
  })], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("Bitte logge Dich ein, um Deine aktuellen Schichten zu sehen."), _c('br'), _vm._v("Falls Du dein Passwort vergessen hast, oder Dich zum ersten\nMal hier anmelden willst, bitte "), _c('a', {
    attrs: {
      "href": "https://salat.pepperz.de/admin-tools/password_reset/",
      "target": "_blank"
    }
  }, [_vm._v("hier entlang")]), _vm._v(".")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4268e61e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1083
// module chunks = 1